import React, { useState, useEffect } from 'react';
import './Resizable3DBox.css'; // Ensure this file is in the same folder for the 3D box styling

const DimCalculator = () => {
  // State for dimensions of the 3D box
  const [dimensions, setDimensions] = useState({
    length: 100,
    width: 100,
    height: 100,
  });

  const [dragging, setDragging] = useState(false);
  const [currentDrag, setCurrentDrag] = useState(null);

  // Handle resizing the box with mouse or touch
  const handleResize = (e) => {
    if (!dragging) return;

    const { clientX, clientY } = e;
    setDimensions((prev) => {
      const newDimensions = { ...prev };

      // Resizing logic based on which side is being dragged
      if (currentDrag === 'length') {
        newDimensions.length = Math.max(clientX - e.target.getBoundingClientRect().left, 50);
      } else if (currentDrag === 'width') {
        newDimensions.width = Math.max(clientY - e.target.getBoundingClientRect().top, 50);
      } else if (currentDrag === 'height') {
        newDimensions.height = Math.max(clientX - e.target.getBoundingClientRect().left, 50);
      }

      return newDimensions;
    });
  };

  const handleTouchResize = (e) => {
    if (!dragging) return;

    const { clientX, clientY } = e.touches[0];
    setDimensions((prev) => {
      const newDimensions = { ...prev };

      // Resizing logic based on which side is being dragged
      if (currentDrag === 'length') {
        newDimensions.length = Math.max(clientX - e.target.getBoundingClientRect().left, 50);
      } else if (currentDrag === 'width') {
        newDimensions.width = Math.max(clientY - e.target.getBoundingClientRect().top, 50);
      } else if (currentDrag === 'height') {
        newDimensions.height = Math.max(clientX - e.target.getBoundingClientRect().left, 50);
      }

      return newDimensions;
    });
  };

  useEffect(() => {
    const stopDragging = () => setDragging(false);
    window.addEventListener('mouseup', stopDragging);
    window.addEventListener('mousemove', handleResize);
    window.addEventListener('touchend', stopDragging);
    window.addEventListener('touchmove', handleTouchResize);

    return () => {
      window.removeEventListener('mouseup', stopDragging);
      window.removeEventListener('mousemove', handleResize);
      window.removeEventListener('touchend', stopDragging);
      window.removeEventListener('touchmove', handleTouchResize);
    };
  }, [dragging, currentDrag]);

  const surfaceArea = 2 * (dimensions.length * dimensions.width + dimensions.width * dimensions.height + dimensions.height * dimensions.length);

  return (
    <div className="resizable-3d-box-container">
      {/* 3D Box */}
      <div
        className="box"
        style={{
          width: `${dimensions.length}px`,
          height: `${dimensions.height}px`,
          transform: `translateZ(${dimensions.width}px)`,
        }}
      >
        {/* Faces of the 3D box */}
        <div className="face front"></div>
        <div className="face back"></div>
        <div className="face left"></div>
        <div className="face right"></div>
        <div className="face top"></div>
        <div className="face bottom"></div>

        {/* Resizing Handles */}
        <div
          className="resizer length"
          onMouseDown={() => {
            setDragging(true);
            setCurrentDrag('length');
          }}
          onTouchStart={() => {
            setDragging(true);
            setCurrentDrag('length');
          }}
        >
          <div className="marker">L</div>
        </div>
        <div
          className="resizer width"
          onMouseDown={() => {
            setDragging(true);
            setCurrentDrag('width');
          }}
          onTouchStart={() => {
            setDragging(true);
            setCurrentDrag('width');
          }}
        >
          <div className="marker">W</div>
        </div>
        <div
          className="resizer height"
          onMouseDown={() => {
            setDragging(true);
            setCurrentDrag('height');
          }}
          onTouchStart={() => {
            setDragging(true);
            setCurrentDrag('height');
          }}
        >
          <div className="marker">H</div>
        </div>
      </div>

      {/* Display current dimensions and surface area */}
      <div className="dimensions-display">
        <h2>Dimensions</h2>
        <p>Length: {dimensions.length.toFixed(2)} units</p>
        <p>Width: {dimensions.width.toFixed(2)} units</p>
        <p>Height: {dimensions.height.toFixed(2)} units</p>
        <p>Surface Area: {surfaceArea.toFixed(2)} sq units</p>
      </div>
    </div>
  );
};

export default DimCalculator;
